var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatBubbleLeftRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7812 9.57491C23.7758 9.89492 24.4688 10.8441 24.4688 11.9342V16.7555C24.4688 18.0342 23.5154 19.1185 22.2409 19.2225C21.8597 19.2537 21.4772 19.2809 21.0938 19.3042V22.7812L17.7188 19.4062C16.1958 19.4062 14.6875 19.3442 13.1965 19.2224C12.8609 19.1951 12.5476 19.0997 12.2681 18.9507M22.7812 9.57491C22.6109 9.52011 22.4317 9.48376 22.2457 9.46831C20.7531 9.34443 19.2433 9.28125 17.7187 9.28125C16.1942 9.28125 14.6844 9.34443 13.1918 9.4683C11.9194 9.57392 10.9688 10.6574 10.9688 11.9342V16.7554C10.9688 17.6974 11.4861 18.5339 12.2681 18.9507M22.7812 9.57491V7.46697C22.7812 5.64288 21.4855 4.06198 19.6766 3.82715C17.3788 3.52885 15.0357 3.375 12.6566 3.375C10.2773 3.375 7.93387 3.52888 5.63584 3.82724C3.82694 4.06209 2.53125 5.64298 2.53125 7.46705V14.4705C2.53125 16.2945 3.82695 17.8754 5.63585 18.1103C6.28494 18.1946 6.93764 18.2673 7.59375 18.3283V23.625L12.2681 18.9507",
    stroke: "inherit",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleLeftRight);
export default __webpack_public_path__ + "static/media/chat-bubble-left-right.27a65d02ea7080e2be1e88ab567454d4.svg";
export { ForwardRef as ReactComponent };